var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnetVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "svg846",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs850"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g935",
    transform: "matrix(0.11362053,0,0,0.10420245,-2.5448212,-2.168098)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    x1: 48,
    x2: 104,
    y1: 96,
    y2: 96,
    id: "line840"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    x1: 152,
    x2: 208,
    y1: 96,
    y2: 96,
    id: "line842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 104,144 a 24,24 0 0 0 48,0 V 56 a 8,8 0 0 1 8,-8 h 40 a 8,8 0 0 1 8,8 v 87 c 0,44.1 -35.3,80.7 -79.4,81 A 80,80 0 0 1 48,144 V 56 a 8,8 0 0 1 8,-8 h 40 a 8,8 0 0 1 8,8 z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    id: "path844"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnetVertical);
export default __webpack_public_path__ + "static/media/magnet-vertical.bd56ddf2134ba4a13b68ae3b07aa2330.svg";
export { ForwardRef as ReactComponent };